import { IStoryletState } from "types/storylet";

/* eslint-disable import/prefer-default-export */

/**
 * Initial state
 * @type {Object}
 */
export const INITIAL_STATE: IStoryletState = {
  addedFriendId: 0,
  isChoosing: false,
  isFetching: false,
  isGoingBack: false,
  isSaving: false,
  isRenaming: false,
  phase: 'Available',
  endStorylet: null,
  dated: false,
  message: null,
  messages: null,
  storylets: [],
  storylet: null,
  socialAct: null,
  externalSocialAct: null,
  rename: null,
  eligibleFriends: null,
  ineligibleContacts: null,
  secondChance: null,
};